import axios from 'axios'
import {useMutation, useQuery, useQueryClient} from 'react-query'
import {WorkOrderData} from "./useWorkOrder";

export interface  WorkReportingDataObject {
    dispatchsendid: string
    tempsaveid: number
    tempfieldsaveid: number
    title: string
    scheduleid: number
    sectiondata: SectionData[]
    isreadonly: boolean
    sections: WorkSections[]

    status: string
    message: string
    woid: number
    dynamiclookuplist: []
    dynamicfieldlist: []
}
export interface  WorkSections {
    RowNumber: number
    sectionname: string
    sectiontitle?: string
    sectionid: number
    filelist: FileData[]
    sectiondata: SectionData[]
    equipmentlist: EquipmentData[]
    companyreplist: CompanyRepList[]
    vehiclelist: VehicleData[]
    employeelist: EmployeeData[]
    jobtypelist: JobTypeList[]
    customerlist: CustomerList[]
    data: Data[]
    dynamiclookuplist: []
    dynamicfieldlist: DynamicData[]
    categorylist: CategoryList[]
    categoryAdded: []
    multiple: boolean
    expand: number
    flist: FieldListObject[]
    dlist?: DataListObject[]
}

export interface  CategoryList {
    categoryid: number
    category: string
}


// 1 - boolean
// 2 - integer Lookup Value
// 3 - integer
// 4 - money (double)
// 5 - text
// 6 - date
// 7 - text ([1,3,5] multi lookup values
// 8 - Datetime
// 9 - Time
// 10 - Signature
// 11 - Photos
// 12 - MAP
// 13 - Label
// 14 - Notes

// "expand":1 --Allow Expand/Collapse (start off collapsed) DEFAULT
// "expand":2 --Allow Expand/Collapse (start off expanded)
// "expand":3 --DON'T Allow Expand/Collapse (expanded ALWAYS)

export interface  DynamicData {
    schedulefieldcontrol: number
    schedulefieldid: number
    schedulefieldheaderid: number
    schedulefieldlabel: string
    schedulefieldreadonly: boolean
    schedulefieldrequired: boolean
    schedulefieldvalue1: boolean
    schedulefieldvalue2: number
    schedulefieldvalue3: number

    schedulefieldvalue4: number
    schedulefieldvalue5: string
    schedulefieldvalue6: string
    schedulefieldvalue7: []
    schedulefieldvalue8: string
    schedulefieldvalue9: string
}

export interface  DynamicGroupData {
    rownumber: number
    sectionname: string
    sectiontitle: string
    sectionid: number
    multiple: boolean
    expand: number
    flist: FieldListObject[]
    dlist?: DataListObject[]
}

export interface FieldListObject {
    id: number
    headerid?: number
    ord: number
    wd: number
    grp: number
    ctrl: number
    ctrlo?: number
    req: boolean
    ro: boolean
    lbl: string
    dependson?: number
    dependsonvalue?: number | string | boolean
    showgroup?: string
    showgroupvalue?: boolean
    group?: string
    min?: string
    max?: string
    keepvalue?: boolean
}

export interface DataListObject {
    id: string
    id2: string
    ord: number
    flist: FieldListValues[]
}

export interface FieldListValues {
    id: number
    v1?: boolean
    v2?: number
    v3?: number
    v4?: number
    v5?: string
    v6?: string
    v7?: []
    v8?: string
    v9?: string
    v10?: string
    v11?: []
    v12?: boolean
    v13?: string
}

export interface  DispatchDataObject {
    dispatchsendid: string
    tempsaveid: number
    title: string
    scheduleid: number
    sectiondata: SectionData[]
    isreadonly: boolean
    sections: Sections[]
    status: string
    message: string
    woid: number
}

export interface  SectionData {
    RowNumber: number
    label: string
    value: string
}

export interface  EquipmentData {
    equipment: string
    equipmentid: number
}

export interface  VehicleData {
    vehicle: string
    vehicleid: number
}

export interface  EmployeeData {
    employee: string
    employeeid: number
}

export interface  CompanyRepList {
    companyrep: string
    companyrepid: number
}

export interface  CustomerList {
    customer: string
    customerid: number
}
export interface  JobTypeList {
    jobtype: string
    jobtypeid: number
}

export interface  FileData {
    id: string
    name: string
    path: string
    serverModified: string
}

export interface  Data {
    emergencyid: number
    customernumber: string
    address: string
    customerid: number
    customer: string
    customerSignedImage: string
    companySignedImage: string
    fieldrepSignedImage: string
}

export interface  Sections {
    RowNumber: number
    sectionname: string
    filelist: FileData[]
    sectiondata: SectionData[]
    equipmentlist: EquipmentData[]
    companyreplist: CompanyRepList[]
    vehiclelist: VehicleData[]
    employeelist: EmployeeData[]
    jobtypelist: JobTypeList[]
    customerlist: CustomerList[]
    data: Data[]
}

export const DivisionsDataDefaults = {
    RowNumber: 0,
    label: "",
    value: ""
}

export const useFetchDispatch = (userGuid: string) => {
    return useQuery<DispatchDataObject>(
        ['dispatch'],
        () => globalFetcher(userGuid),
        {
            staleTime: 120000,
            keepPreviousData: false
        }
    )
}

export const useUpdateTempDispatch = () => {
    const queryClient = useQueryClient()

    return useMutation((body: any) =>
        axios.put(`dispatchsave`, body), {
        onSuccess: () => {
            // queryClient.invalidateQueries(['dispatch'])
        }
    })
}

export const useUpdateDispatch = () => {
    const queryClient = useQueryClient()

    return useMutation((body: any) =>
        axios.put(`dispatch2`, body), {
        onSuccess: () => {
            // queryClient.invalidateQueries(['dispatch'])
        }
    })
}

export const useUpdateWorkReporting = () => {
    const queryClient = useQueryClient()

    return useMutation((body: any) =>
        axios.put(`workreporting`, body), {
        onSuccess: () => {
            // queryClient.invalidateQueries(['dispatch'])
        }
    })
}

export const useDeleteDispatch = () => {
    const queryClient = useQueryClient()

    return useMutation((body: any) =>
        axios.delete(`dispatch`, {data: body}), {
        onSuccess: () => {
            queryClient.invalidateQueries(['dispatch'])
        }
    })
}

export const globalFetcher = async (userGuid: string) => {
    const { data } = await axios.get('/dispatch/' + userGuid, {})
    const parsedData = JSON.parse(data.jsonString)
    return parsedData as DispatchDataObject
}
